import { gql } from '@apollo/client';

export const GET_ID = gql`
  query GetMyAcuvueId {
    profile {
      id
      myAcuvueId
    }
  }
`;
